// extracted by mini-css-extract-plugin
export default {"input":"Input_input__B0VmP","halfWidth":"Input_halfWidth__n8Dj-"};